export default {
    askEve: "Pregunta a Eve",
    controlHub: "Centro de Control",
    dashboard: "Dashboard",
    calendar: "Calendario",
    containers: "Contenedor",
    activity: "Actividad",
    quotes: "Cotizaciones",
    orders: "Pedidos",
    receivers: "Socios Comerciales",
    businessPartners: "Socios Comerciales",
    shippers: "Expedidores",
    team: "Equipo",
    addressBook: "Libreta de Direcciones",
    settings: "Configuración",
    companies: "Empresas",
    support: "Soporte",
    logout: "Cerrar sesión",
    documents: "Documentos",
    eveDrive: "Eve Drive",
    workflows: "Flujos de Trabajo",
    knowledgeBase: "Base de Conocimiento",
    analytics: "Analytics",
    unreadNotifications: "{{count}} notificaciones no leídas",
};
